__turbopack_context__.v({
  "multi_livestream__schedule_link": "StationInfo-module-scss-module__TV8Wra__multi_livestream__schedule_link",
  "multi_livestream__station_info": "StationInfo-module-scss-module__TV8Wra__multi_livestream__station_info",
  "multi_livestream__station_info__name_link": "StationInfo-module-scss-module__TV8Wra__multi_livestream__station_info__name_link",
  "multi_livestream__station_name": "StationInfo-module-scss-module__TV8Wra__multi_livestream__station_name",
  "timezone": "StationInfo-module-scss-module__TV8Wra__timezone",
});
